import { render, staticRenderFns } from "./FoodTodo.vue?vue&type=template&id=4c8ee514&scoped=true&lang=pug&"
import script from "./FoodTodo.vue?vue&type=script&lang=ts&"
export * from "./FoodTodo.vue?vue&type=script&lang=ts&"
import style0 from "./FoodTodo.vue?vue&type=style&index=0&id=4c8ee514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ee514",
  null
  
)

export default component.exports